<script setup lang="ts">
import type { Article } from "~/types/article"

defineProps<{
  article: Article;
}>()
</script>

<template>
	<div class="font-national2condensed text-mobile-article-h1 font-medium sm:text-desktop-article-h1">
		<h1 v-if="article.titleHtml" class="inline" v-html="article.titleHtml" />

		<h1 v-else class="inline">
			{{ article.title }}
		</h1>
	</div>
</template>
